module.exports = __webpack_public_path__ + "img/9788957980088.074cffb8.jpg";